<template>
  <v-menu
    v-model="opened"
    :close-on-content-click="false"
    :nudge-right="40"
    transition="scale-transition"
    offset-y
    min-width="300px"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        prepend-inner-icon="mdi-calendar"
        hide-details
        outlined
        readonly
        v-model="formattedDate"
        :label="label"
        :class="inputClass"
        v-on="on"
        v-bind="$attrs"
        @blur="onBlur"
      />
    </template>
    <v-card>
      <v-date-picker v-model="localValue" @input="onSelectDate"/>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="opened = false">Fechar</v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
import DateUtils from './utils/date-formatter-utils';

export default {
  props: ['value', 'label', 'inputClass'],
  data() {
    return {
      opened: false,
    };
  },
  methods: {
    onSelectDate() {
      this.opened = false;
    },
    onBlur(event) {
      this.$emit('blur', event);
    },
  },
  computed: {
    localValue: {
      get() {
        return this.value;
      },
      set(localValue) {
        this.$emit('input', localValue);
      },
    },
    formattedDate() {
      return DateUtils.formatSimple(this.localValue);
    },
  },
};
</script>
